import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    id: "event-type",
    class: "mb-3 py-1 px-2 rounded-xl w-fit bg-blue-50 text-center text-blue-700 font-medium"
};
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-t-[1px] border-gray-200 my-[5px]" }, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-t-[1px] border-gray-200 mt-[8px] mb-[16px]" }, null, -1);
const _hoisted_6 = { key: 2 };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-t-[1px] border-gray-200 mt-[8px] mb-[16px]" }, null, -1);
const _hoisted_8 = {
    key: 3,
    class: "flex items-baseline justify-between mt-2 mb-2"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "text-sm font-semibold text-primary-700" }, "Join Meeting", -1);
const _hoisted_10 = { class: "w-full text-sm" };
const _hoisted_11 = { class: "text-primary-700 text-sm font-medium" };
import { convertAndFormatSource, isMeetingURLValid } from '@/helper/helper';
import AppointmentUsers from './AppointmentUsers.vue';
import AppState, { setViewActivityLog } from '@/states/view_appointment';
import { ArrowRightIcon, ChevronDownIcon, Copy01Icon, NotificationTextIcon, VideoRecorderIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import IconTextContainer from '../common/IconTextContainer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppointmentDetails',
    props: {
        isClassBookingView: Boolean,
        router: Object,
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const guestCount = computed(() => {
            var _a, _b, _c, _d, _e;
            const guestDetailsCount = ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.isLocal)
                ? AppState.guestsDetails.length
                : (_c = (_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.guests) === null || _c === void 0 ? void 0 : _c.length;
            return (((_d = AppState.appointmentDetail) === null || _d === void 0 ? void 0 : _d.guestCount) ||
                guestDetailsCount ||
                ((_e = AppState.appointmentsRef) === null || _e === void 0 ? void 0 : _e.length));
        });
        const isEventTypeAppointment = computed(() => {
            var _a;
            return ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.eventType) === 'appt';
        });
        const attendeeCount = computed(() => {
            let count;
            if (isEventTypeAppointment.value)
                count = guestCount.value + 1;
            else
                count = guestCount.value;
            return count === 1
                ? `1 ${t('appointmentModal.attendee').toLowerCase()}`
                : `${count} ${t('appointmentModal.multiple_attendee_label').toLowerCase()}`;
        });
        const attendeeCountDescription = computed(() => {
            const guestDescription = guestCount.value === 1
                ? t('appointmentModal.guest').toLowerCase()
                : t('appointmentModal.guests').toLowerCase();
            if (!isEventTypeAppointment.value) {
                return `${guestCount.value} ${guestDescription}`;
            }
            const contactCount = Math.max(AppState.appointmentsRef.length, 1);
            const contactDescription = contactCount === 1
                ? t('appointmentModal.contact').toLowerCase()
                : t('appointmentModal.contacts').toLowerCase();
            return AppState.appointmentsRef.length > 0
                ? `${contactCount} ${contactDescription}`
                : `${contactCount} ${contactDescription}, ${guestCount.value} ${guestDescription}`;
        });
        // Function to be called on click join meeting to open the meeting URL
        const onClickJoinMeeting = () => {
            var _a;
            window.open((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.address, '_blank');
        };
        // FUnction to be called to copy the meeting URL
        const onClickCopy = () => {
            var _a, _b;
            if ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.address) {
                navigator.clipboard.writeText((_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.address);
            }
        };
        const getEventType = (eventType) => {
            switch (eventType) {
                case 'google':
                    return t('appointmentModal.google_event');
                case 'outlook':
                    return t('appointmentModal.outlook_event');
                case 'event':
                    return t('appointmentModal.blocked_slot');
                default:
                    return t('appointmentModal.appointment');
            }
        };
        const showViewActivityLog = computed(() => {
            var _a;
            return (!props.isClassBookingView &&
                ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.eventType) !== 'event');
        });
        const isEventBlockedSlot = computed(() => {
            var _a;
            return ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.eventType) === 'event';
        });
        const isBlockedSlot = computed(() => {
            var _a;
            return !((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.contactId);
        });
        const showAttendees = computed(() => {
            if (isBlockedSlot.value) {
                return false;
            }
            return true;
        });
        const showExpandableAttendees = computed(() => {
            return AppState.appointmentsRef.length > 0 || guestCount.value > 0;
        });
        const roomName = computed(() => {
            var _a, _b, _c;
            const assignedResources = (_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.assignedResources;
            const assignedRoom = (_c = (_b = AppState === null || AppState === void 0 ? void 0 : AppState.globalRooms) === null || _b === void 0 ? void 0 : _b.map(e => e)) === null || _c === void 0 ? void 0 : _c.find((room) => {
                return room.isActive && assignedResources.includes(room._id);
            });
            return assignedRoom === null || assignedRoom === void 0 ? void 0 : assignedRoom.name;
        });
        const equipmentName = computed(() => {
            var _a, _b, _c;
            const assignedResources = (_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.assignedResources;
            const assignedRoom = (_c = (_b = AppState === null || AppState === void 0 ? void 0 : AppState.globalEquipments) === null || _b === void 0 ? void 0 : _b.map(e => e)) === null || _c === void 0 ? void 0 : _c.find((equip) => {
                return equip.isActive && assignedResources.includes(equip._id);
            });
            return assignedRoom === null || assignedRoom === void 0 ? void 0 : assignedRoom.name;
        });
        const isAppointmentDeleted = computed(() => {
            var _a;
            return (_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.deleted;
        });
        const onClickActivityLog = () => {
            var _a;
            if (isAppointmentDeleted.value) {
                const router = props === null || props === void 0 ? void 0 : props.router;
                const route = router === null || router === void 0 ? void 0 : router.resolve({
                    name: 'audit-location-v2',
                    params: { location_id: AppState.locationId },
                    query: {
                        documentType: 'CALENDAR_EVENT',
                        actionType: 'DELETED',
                        documentId: (_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.id,
                    },
                });
                if (route)
                    window.open(route.href, '_blank');
            }
            else
                setViewActivityLog(true);
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: _normalizeClass({
                        ' bg-[#F9FAFB] rounded-md  px-[15px] pt-[15px] pb-[5px]': (_a = _unref(AppState).appointmentDetail) === null || _a === void 0 ? void 0 : _a.deleted,
                    })
                }, [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(getEventType((_b = _unref(AppState).appointmentDetail) === null || _b === void 0 ? void 0 : _b.eventType)), 1),
                    (_unref(AppState).appointmentOwnerDetails)
                        ? (_openBlock(), _createBlock(IconTextContainer, {
                            key: 0,
                            text: ((_c = _unref(AppState).appointmentOwnerDetails) === null || _c === void 0 ? void 0 : _c.name) || '-',
                            title: _ctx.$t('appointmentModal.appointment_owner'),
                            icon: "UserCircleIcon",
                            id: "appointment-owner"
                        }, null, 8, ["text", "title"]))
                        : _createCommentVNode("", true),
                    (showExpandableAttendees.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (showAttendees.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "flex items-baseline justify-between mt-2",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(AppState).viewUserInfo = !_unref(AppState).viewUserInfo))
                                }, [
                                    _createVNode(IconTextContainer, {
                                        title: ((_d = _unref(AppState).appointmentDetail) === null || _d === void 0 ? void 0 : _d.eventType) !== 'event'
                                            ? attendeeCount.value
                                            : '-',
                                        text: ((_e = _unref(AppState).appointmentDetail) === null || _e === void 0 ? void 0 : _e.eventType) !== 'event'
                                            ? attendeeCountDescription.value
                                            : '',
                                        primaryColor: true,
                                        icon: "Users01Icon",
                                        id: "contact-details"
                                    }, null, 8, ["title", "text"]),
                                    (((_f = _unref(AppState).appointmentDetail) === null || _f === void 0 ? void 0 : _f.eventType) !== 'event')
                                        ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                                            key: 0,
                                            class: "w-5 h-5 text-primary-600 cursor-pointer",
                                            id: "open-user-details-icon"
                                        }))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(AppState).viewUserInfo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _hoisted_4,
                                    _createVNode(AppointmentUsers, {
                                        "is-class-booking-view": __props.isClassBookingView,
                                        router: __props.router,
                                        "show-appointment-owner": true
                                    }, null, 8, ["is-class-booking-view", "router"]),
                                    _hoisted_5
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : (_unref(AppState).contactDetails)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(AppointmentUsers, {
                                    "is-class-booking-view": __props.isClassBookingView,
                                    router: __props.router,
                                    "show-appointment-owner": false
                                }, null, 8, ["is-class-booking-view", "router"]),
                                _hoisted_7
                            ]))
                            : _createCommentVNode("", true),
                    (!isEventBlockedSlot.value && !((_g = _unref(AppState).calendarDetail) === null || _g === void 0 ? void 0 : _g.isServiceCalendar))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(IconTextContainer, {
                                title: ((_h = _unref(AppState).appointmentDetail) === null || _h === void 0 ? void 0 : _h.address) || '-',
                                icon: "MarkerPin02Icon",
                                id: "meeting-details"
                            }, null, 8, ["title"]),
                            (_unref(isMeetingURLValid)((_j = _unref(AppState).appointmentDetail) === null || _j === void 0 ? void 0 : _j.address))
                                ? (_openBlock(), _createBlock(_unref(Copy01Icon), {
                                    key: 0,
                                    class: "w-5 h-5 text-primary-600 cursor-pointer",
                                    id: "copy-meeting-icon",
                                    onClick: onClickCopy
                                }))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (_unref(isMeetingURLValid)((_k = _unref(AppState).appointmentDetail) === null || _k === void 0 ? void 0 : _k.address) &&
                        !((_l = _unref(AppState).calendarDetail) === null || _l === void 0 ? void 0 : _l.isServiceCalendar))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            id: "join-meeting-button",
                            onClick: onClickJoinMeeting,
                            class: "bg-primary-50 mt-1 mb-4 w-full p-[10px] flex flex-row gap-2 rounded-lg justify-center items-center cursor-pointer"
                        }, [
                            _createVNode(_unref(VideoRecorderIcon), {
                                class: "w-6 text-primary-700 mr-2",
                                id: "video-recorder-icon"
                            }),
                            _hoisted_9
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(IconTextContainer, {
                                text: ((_m = _unref(AppState).calendarDetail) === null || _m === void 0 ? void 0 : _m.name) || '-',
                                title: _ctx.$t('appointmentModal.calendar'),
                                icon: "CalendarCheck02Icon",
                                id: "calendar-details"
                            }, null, 8, ["text", "title"]),
                            _createVNode(IconTextContainer, {
                                text: _unref(convertAndFormatSource)((_o = _unref(AppState).appointmentDetail) === null || _o === void 0 ? void 0 : _o.source) || '-',
                                title: _ctx.$t('appointmentModal.source'),
                                icon: "LinkExternal01Icon",
                                id: "appointment-source"
                            }, null, 8, ["text", "title"]),
                            _createVNode(IconTextContainer, {
                                text: ((_p = _unref(AppState).userDetails) === null || _p === void 0 ? void 0 : _p.name) || '-',
                                title: _ctx.$t('appointmentModal.booked_by'),
                                icon: "UserCircleIcon",
                                id: "appointment-booked-by"
                            }, null, 8, ["text", "title"]),
                            ((_q = _unref(AppState).calendarDetail) === null || _q === void 0 ? void 0 : _q.isServiceCalendar)
                                ? (_openBlock(), _createBlock(IconTextContainer, {
                                    key: 0,
                                    text: roomName.value || '-',
                                    title: _ctx.$t('appointmentModal.room'),
                                    icon: "Building02Icon",
                                    id: "appointment-booked-by"
                                }, null, 8, ["text", "title"]))
                                : _createCommentVNode("", true),
                            ((_r = _unref(AppState).calendarDetail) === null || _r === void 0 ? void 0 : _r.isServiceCalendar)
                                ? (_openBlock(), _createBlock(IconTextContainer, {
                                    key: 1,
                                    text: equipmentName.value || '-',
                                    title: _ctx.$t('appointmentModal.equipment'),
                                    icon: "CompassIcon",
                                    id: "appointment-booked-by"
                                }, null, 8, ["text", "title"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ], 2),
                (showViewActivityLog.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "view-activity-log-button",
                        class: "flex gap-3 items-center mt-4 cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (onClickActivityLog()), ["prevent"]))
                    }, [
                        _createVNode(_unref(NotificationTextIcon), { class: "text-primary-700 w-5" }),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(isAppointmentDeleted.value
                            ? _ctx.$t('appointmentModal.view_audit_log')
                            : _ctx.$t('appointmentModal.view_activity_log')), 1),
                        _createVNode(_unref(ArrowRightIcon), { class: "text-primary-700 h-5 w-5" })
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
